<template>
  <div
    id="list-search-field"
    :class="{grow: open}"
    class="d-flex"
  >
    <v-btn
      class="ma-0"
      icon
      @click.stop="iconPress"
    >
      <v-icon
        class="px-2"
        color="metalBlue"
      >
        mdi-magnify
      </v-icon>
    </v-btn>
    <v-text-field
      ref="field"
      v-model="localText"
      class="search-text-field"
      :class="{grow: open}"
      color="metalBlue"
      height="15"
      single-line
      label="検索"
      @blur="fadeaway"
      @keydown.enter="searchList()"
    />
    <v-btn
      v-show="open"
      class="ma-0"
      icon
      @click.stop="clearText"
    >
      <v-icon
        class="px-2"
        color="metalBlue"
      >
        mdi-close
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      localText: '',
      openTrigger: false
    }
  },
  computed: {
    ...mapState('list', ['searchText']),
    open () {
      return this.openTrigger || !!this.localText
    }
  },
  watch: {
    searchText (val) {
      this.localText = val
      this.openTrigger = !!val
    }
  },
  mounted () {
    this.localText = this.searchText
    this.openTrigger = !!this.localText
  },
  methods: {
    ...mapActions('list', ['search']),
    iconPress () {
      if (this.open) {
        this.searchList()
      }
      this.openTrigger = true
      this.$refs.field.focus()
    },
    searchList () {
      if (this.localText !== this.searchText) {
        this.search(this.localText)
      }
    },
    fadeaway (e) {
      if (e.relatedTarget?.parentElement?.id === 'list-search-field') return

      this.searchList()

      if (!this.localText) {
        this.openTrigger = false
      }
    },
    clearText () {
      this.localText = ''
      this.$refs.field.focus()
    }
  }
}
</script>

<style lang="scss" scoped>
#list-search-field {
  position: absolute;
  top: -6px;
  right: -55px;
  background: white;
  border: 2px var(--metal-blue) solid;
  border-radius: 50px;

  &.grow{
    background: #f3f8ff;
  }

.search-text-field {
  width: 0;
  opacity: 0;
  transition: width 0.2s;

  &.grow {
    width: 275px;
    opacity: 1;
  }
}

  /deep/ {
    .v-text-field>.v-input__control>.v-input__slot:after{
      display: none;
    }
    .theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea{
      padding-top: 0;
    }
    .theme--light.v-text-field>.v-input__control>.v-input__slot:before{
      display: none;
    }
    .v-text-field__slot .v-label {
    color: #333 !important;
    }
    .theme--light.v-label {
      font-size: 1.1rem;
      top: 0px;
    }
  }
}
</style>
